import React from "react";
import CancelIcon from "@mui/icons-material/Cancel";

function SingleCategoryDetails({
  setIsLoading,
  setViewTab,
  data,
  //   currentPage,
}) {
  let details = data?.sub_categories;
  return (
    <div className="bg-white p-6 rounded-md">
      <div className="flex justify-end">
        <CancelIcon
          className="cursor-pointer"
          onClick={() => setViewTab(false)}
        />
      </div>

      <div className="flex flex-col items-center gap-4">
        <table className="w-[400px] bg-white border border-gray-300">
          <thead>
            <tr className="bg-gray-200">
              <th className="py-2 px-4 border-b border-gray-300">
                Sub-Category
              </th>
            </tr>
          </thead>
          {details.length === 0 ? (
            <h4 className="text-center py-2">No avaible Sub-category yet</h4>
          ) : (
            <tbody>
              {details?.map((item) => (
                <tr
                  key={item?.id}
                  className="hover:bg-gray-100 border-b border-gray-300"
                >
                  <td className="py-2 px-4 text-center text-wrap">
                    {item?.sub_cat_name}
                  </td>
                </tr>
              ))}
            </tbody>
          )}
        </table>
      </div>
    </div>
  );
}

export default SingleCategoryDetails;
